import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextAction } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Question } from './question';
export const MAX_VISIBLE_QUESTIONS = 3;
const questionsListCss = "qdsi1u";
export const QuestionsList = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(questionsListCss, props.className)} />;
});
const overflowExpandedCss = "o2pcuih";
const overflowWrapperCss = "or8824g";
const overflowInnerCss = "odq53qf";
const showMoreToggleCss = "solu5fs";
export const ShowMoreToggle = ({
  isExpanded,
  onClick
}) => <BareButton onClick={onClick} className={showMoreToggleCss}>
    <BodyText color={colorTextAction}>
      {isExpanded ? I18n.t('publisher.meetings.tabs.questions_toggle.show_less') : I18n.t('publisher.meetings.tabs.questions_toggle.show_all')}
    </BodyText>
  </BareButton>;
export const OverflowQuestions = ({
  questions,
  isExpanded
}) => {
  if (!questions || questions.length <= MAX_VISIBLE_QUESTIONS) return null;
  const overflow = questions.slice(MAX_VISIBLE_QUESTIONS);
  return <div data-testid="questions-overflow" className={classNames(overflowWrapperCss, {
    [overflowExpandedCss]: isExpanded
  })} aria-hidden={!isExpanded}>
      <div className={overflowInnerCss}>
        {overflow.map(question => <Question key={question.name} {...question} />)}
      </div>
    </div>;
};

require("./questions_overflow.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./questions_overflow.js");